import FilterCircleIcon from './FilterCircleIcon';

export default FilterCircleIcon;
